module.exports = __webpack_public_path__ + "static/media/52820237_2453002244774952_2918221426257297408_o.121fc99c.jpg";